import { Component, OnInit, ViewChild, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import {
  config,
  MemberDetails,
  MemberQuery,
  BalanceQuery,
  ProviderName,
  MemberCard,
  MemberCardQuery,
  KeyValuePair,
  NotificationCenterService,
  NotificationCenterQuery,
  Cart,
  CartQuery,
  Card,
  CardQuery,
} from '@fgb/core';
import { CardService } from '@fgb/core';
import { AuthService } from '@fgb/core';
import { Observable, Subject } from 'rxjs';
import { tap, map, takeUntil } from 'rxjs/operators';
import { Populations } from 'src/app/shared/utilities/populations';
import { ProductCode } from 'src/app/shared/utilities/product-code';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { animate, state, style, transition, trigger } from '@angular/animations';

@Component({
  selector: 'fgb-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  animations: [
    trigger('rightNavAnimation', [
      state('open', style({ transform: 'translateX(0)', opacity: 1 })),
      state('close', style({ transform: 'translateX(100%)', opacity: 0.2 })),
      transition('open <=> close', [animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)')]),
    ]),
    trigger('rightMenuOverlayAnimation', [
      transition(':enter', [
        style({ opacity: 0, display: 'none' }),
        animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 1, display: 'block' })),
      ]),
      transition(':leave', [
        style({ opacity: 1, display: 'block' }),
        animate('300ms cubic-bezier(0.25, 0.8, 0.25, 1)', style({ opacity: 0, display: 'none' })),
      ]),
    ]),
  ],
})
export class NavBarComponent implements OnInit, OnDestroy {
  @ViewChild('greedyNav', { static: true }) greedyNav: ElementRef;
  @ViewChild('greedyDropdown', { static: true }) greedyDropdown: ElementRef;
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    const target = event.target as HTMLElement;
    if (target.closest('.right-nav-menu-overlay')) {
      this.isNavOpen = false;
      return;
    }

    if (this.isNavOpen && !this._el.nativeElement.contains(target)) {
      this.isNavOpen = false;
    }
  }
  isNavOpen: boolean = false;
  breakPoints: number[] = [];
  shownLinks: number = 0;
  hiddenLinks: number = 0;
  populations = Populations;
  productcode = ProductCode;
  memberDetails$: Observable<MemberDetails | undefined>;
  combinedCard$: Observable<number | undefined>;
  loyaltyPointsCard$: Observable<number | undefined>;
  card$: Observable<MemberCard | undefined>;
  unseenNotificationCount$: Observable<number>;
  isCollapsed = false;
  sub: any;
  name$: Observable<string>;
  selectedMember: string;
  cards$: Observable<Card[]>;
  totalItems$: Observable<number>;
  basketPointsTotal$: Observable<number | undefined>;
  items$: Observable<Cart[] | undefined>;
  currentLanguage: string = '';
  private _destroyed$ = new Subject<void>();
  ticketTradeLink: string;
  constructor(
    private translate: TranslateService,
    public router: Router,
    public cardService: CardService,
    public memberQuery: MemberQuery,
    private authService: AuthService,
    private balanceQuery: BalanceQuery,
    private memberCardQuery: MemberCardQuery,
    private cardQuery: CardQuery,
    private notificationService: NotificationCenterService,
    private notificationQuery: NotificationCenterQuery,
    private cartQuery: CartQuery,
    private _el: ElementRef
  ) {}

  useLanguage(language: string) {
    this.translate.use(language);
  }

  ngOnInit() {
    this.loyaltyPointsCard$ = this.balanceQuery.selectPurse(config.purseConfig.virtualLoyalty);
    this.combinedCard$ = this.balanceQuery.selectPurse(config.purseConfig.combined);
    this.memberDetails$ = this.memberQuery.selectMemberDetails();
    this.card$ = this.memberCardQuery.selectObservedMemberCard();
    this.unseenNotificationCount$ = this.notificationQuery.unseenNotificationsCount$;

    this.initMarketplaceCart();
    this.initAccountSwitch();
    this.initLcid();
    this.retailLink();

    this.router.events.subscribe(() => {
      this.isNavOpen = false;
    });
  }

  ngOnDestroy() {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  initAccountSwitch() {
    this.name$ = this.memberQuery.selectMemberDetails().pipe(
      map((m) => {
        if (m) {
          return `${m.FirstName} ${m.Surname}`;
        }
        return '';
      })
    );

    this.selectedMember = this.memberQuery.getUserContext().memberId;
    this.cards$ = this.cardQuery.selectCards().pipe(
      map((cards: Card[]) =>
        cards
          .sort((a, b) => parseInt(a.Seat) - parseInt(b.Seat))
          .sort((a, b) => parseInt(a.Row) - parseInt(b.Row))
          .sort((a, b) => parseInt(a.Area) - parseInt(b.Area))
      )
    );
  }

  initLcid() {
    this.memberQuery.userContext$.pipe(takeUntil(this._destroyed$)).subscribe((user) => {
      if (user && user.lcid) {
        if (user.lcid === '2057') {
          this.currentLanguage = 'EN';
        } else if (user.lcid === '3084') {
          this.currentLanguage = 'FR';
        } else if (user.lcid === '1037') {
          this.currentLanguage = 'HE';
        } else if (user.lcid === '1033') {
          this.currentLanguage = 'US';
        }
      }
    });
  }

  initMarketplaceCart() {
    this.totalItems$ = this.cartQuery.updateTotalItems();
    this.basketPointsTotal$ = this.cartQuery.updateBasketPointsTotal();
    this.items$ = this.cartQuery.selectAllMarketplaceCartData();
  }

  logout() {
    this.authService
      .logout()
      .pipe(tap(() => this.router.navigate(['/login'])))
      .toPromise();
  }

  selectCard() {
    this.router.navigate(['/login']);
  }

  LoginThirdParty() {
    let options = [{ key: 'Url', value: 'https://sdp.sportsbingo.ballparkapps.com/?bingoUser={1}' }] as KeyValuePair[];
    this.authService.loginThirdParty(ProviderName.SidelineSports, 1, '', true, options);
  }

  toggleNotificationCenter(open: boolean) {
    this.notificationService.updateIsOpen(open);
  }

  loginWithCard(memberId: string) {
    this.authService.switchUser(memberId).toPromise();
  }

  closeDropDown(dropdown: NgbDropdown) {
    dropdown.close();
  }

  retailLink() {
    this.translate
      .stream('ticket.trade.link.url')
      .pipe(takeUntil(this._destroyed$))
      .subscribe((data: string) => {
        this.ticketTradeLink = data;
      });
  }
}
